import React, { useMemo, useEffect, useRef, useState } from "react"
import { Row, Col, Label } from "reactstrap"
import FormikCreatableSelect from "components/Common/FormikCreatableSelect"
import InputField from "components/Common/InputField"
import { useGetCompaniesList } from "hooks/useInventory" // your hook

const CompanyStaffSelector = ({
  formik,
  companyField,
  staffFieldPrefix, // sender / receiver
  labelPrefix,
}) => {
  const staffField = `${staffFieldPrefix}Staff`
  const prevCompanyRef = useRef(null)
  const [searchTerm, setSearchTerm] = useState("")

  // -------------------- Fetch companies --------------------
  const companyData = useGetCompaniesList({ search: searchTerm })
  const companies = useMemo(() => companyData?.data?.data || [], [companyData])
  const loading = companyData?.isLoading || false
  console.log(searchTerm)

  // -------------------- Company Options --------------------
  const companyOptions = useMemo(
    () =>
      companies.map(c => ({
        value: String(c.id),
        label: c.name,
        staff: c.staff || [],
      })),
    [companies]
  )

  // -------------------- Selected Company --------------------
  const selectedCompany = useMemo(() => {
    const companyId = formik.values[companyField]
    if (!companyId) return null
    return companies.find(c => String(c.id) === String(companyId))
  }, [formik.values[companyField], companies])

  // -------------------- Staff Options --------------------
  const staffOptions = useMemo(() => {
    if (!selectedCompany?.staff?.length) return []
    return selectedCompany.staff.map(s => ({
      value: String(s.id),
      label: s.name,
    }))
  }, [selectedCompany])

  // -------------------- Auto-fill on staff select --------------------
  useEffect(() => {
    const staffId = formik.values[staffField]
    if (!staffId || !selectedCompany) return

    const staff = selectedCompany.staff.find(
      s => String(s.id) === String(staffId)
    )
    if (!staff) return

    formik.setFieldValue(`${staffFieldPrefix}Name`, staff.name || "")
    formik.setFieldValue(
      `${staffFieldPrefix}Mobile`,
      Array.isArray(staff.mobile) ? staff.mobile[0] : staff.mobile || ""
    )
    formik.setFieldValue(
      `${staffFieldPrefix}Designation`,
      staff.designation || ""
    )
  }, [formik.values[staffField], selectedCompany])

  // -------------------- Reset staff when company changes --------------------
  useEffect(() => {
    const currentCompany = formik.values[companyField]
    if (prevCompanyRef.current === currentCompany) return
    prevCompanyRef.current = currentCompany

    formik.setFieldValue(staffField, "")
    formik.setFieldValue(`${staffFieldPrefix}Name`, "")
    formik.setFieldValue(`${staffFieldPrefix}Mobile`, "")
    formik.setFieldValue(`${staffFieldPrefix}Designation`, "")
    
  }, [formik.values[companyField]])



  return (
    <>
      <Row>
        {/* -------------------- Company -------------------- */}
        <Col md={6}>
          <FormikCreatableSelect
            name={companyField}
            label={`${labelPrefix} Company`}
            formik={formik}
            options={companyOptions}
            placeholder="Search company..."
          />
        </Col>

        {/* -------------------- Staff -------------------- */}
        <Col md={6}>
          <FormikCreatableSelect
            label={`${labelPrefix} Staff`}
            name={staffField}
            options={staffOptions}
            formik={formik}
            placeholder={
              selectedCompany ? "Select staff..." : "Select company first"
            }
            isDisabled={!selectedCompany}
          />
        </Col>
      </Row>

      {/* -------------------- Name / Mobile / Designation -------------------- */}
      <Row className="mt-2">
        <Col md={4}>
          <Label>Name</Label>
          <InputField
            name={`${staffFieldPrefix}Name`}
            value={formik.values[`${staffFieldPrefix}Name`]}
            onChange={formik.handleChange}
          />
        </Col>

        <Col md={4}>
          <Label>Mobile</Label>
          <InputField
            name={`${staffFieldPrefix}Mobile`}
            value={formik.values[`${staffFieldPrefix}Mobile`]}
            onChange={formik.handleChange}
          />
        </Col>

        <Col md={4}>
          <Label>Designation</Label>
          <InputField
            name={`${staffFieldPrefix}Designation`}
            value={formik.values[`${staffFieldPrefix}Designation`]}
            onChange={formik.handleChange}
          />
        </Col>
      </Row>
    </>
  )
}

export default CompanyStaffSelector
